import { render } from "./AccountCreate.vue?vue&type=template&id=bbc09102"
import script from "./AccountCreate.vue?vue&type=script&lang=ts"
export * from "./AccountCreate.vue?vue&type=script&lang=ts"
script.render = render

export default script